import { diContainer } from '../../libs/container';

export class FetchError extends Error {
    constructor(private readonly status: number, private readonly ok: boolean, public readonly message: string) {
        super();
    }
}
export interface RequestConfig extends RequestInit {
    headers: HeadersInit;
}

export class RequestHandler {
    public async run(url: string, options: RequestConfig): Promise<any> {
        if (options.body) {
            options.body = JSON.stringify(options.body);
        }
        const headers = options.headers ? new Headers(options.headers) : new Headers();

        if (!headers.has('Content-Type')) {
            headers.set('Content-Type', 'application/json');
        }

        options.headers = headers;

        const response = await fetch(url, options);
        const data = await response.json();
        if (!response.ok) {
            throw new FetchError(response.status, response.ok, data?.fault?.message || data?.message || 'Error');
        }

        return data;
    }
}

diContainer.bindAsConstant(RequestHandler, new RequestHandler());
